<template>
    <DateFromTimestamp :timestamp="timestamp" :options="{
        dateStyle: 'long'
    }" />
</template>
<script>

import DateFromTimestamp from './DateFromTimestamp.vue';

export default {
    components: {
        DateFromTimestamp
    },
    props: {
        timestamp: Number,
    }
}
</script>